import { createSlice } from "@reduxjs/toolkit";
export type ViewType = "table" | "card" | "detail";

const initialState: { data: ViewType } = {
  data: "table",
};

export const PendingProjectsListViewTypeSlice = createSlice({
  name: "PendingProjectsListViewType",
  initialState,
  reducers: {
    updatePendingProjectsListViewType(state, action) {
      state.data = action.payload;
    },
  },
});
export const { updatePendingProjectsListViewType } =
  PendingProjectsListViewTypeSlice.actions;

